const Mn = require('backbone.marionette');
const _ = require('underscore');
const ProductThumbnailView = require('@component/product-thumbnail').default;

const setChildView = ({ childView, poolParams }) => {
  if (childView) {
    return childView;
  }
  const data = {
    tagName: 'li',
  };
  if (poolParams) {
    data.options = poolParams.thumbnailAttrs;
  }
  return ProductThumbnailView.extend(data);
};

const View = Mn.ItemView.extend({
  initialize(opts) {
    this.id = _.uniqueId();
    this.childView = setChildView(opts);
    this.model = opts.model;
    this.model.set({
      id: this.id,
    });
    // this.model.fetch({});
    this.collection = this.model.get('productPoolMedia').collection;

    if (opts.el) {
      this.el = opts.el;
    }
  },

  // childViewContainer: ".product-pool-media",
  onRender() {
    console.log('rendering ProductPoolMedia');
  },
  /* render: function(){
        var html = this.template(this.model.toJSON());
        console.debug(html);
        this.$el.html(html);
    }, */
});

module.exports = View;
